var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVtEHov(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.73252 73.6602C4.3573 51.2151 0.291781 31.6943 22.1962 23.2811C33.7157 18.8567 60.8642 14.5065 78.4239 21.7896C94.9376 24.494 99.0733 43.5835 102.904 53.6933C110.985 75.0172 88.1303 87.4577 66.2258 95.8709C44.3213 104.284 16.8133 94.9841 8.73252 73.6602Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5079 62.6347C41.2148 62.8163 39.1102 68.0748 38.7195 70.6813L39.2739 73.4254C39.903 75.1059 42.2177 78.6768 46.4427 79.517C51.724 80.5672 56.62 74.6923 56.622 71.118C56.6241 67.5436 53.1243 62.4076 46.5079 62.6347Z",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2222 68.4447C92.2963 68.1855 78.5556 67.9781 63 69.2225",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.5557 54.7583C64.6146 54.3444 45.2527 54.0133 23.3335 55.9999",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6209 69.6964C26.9304 70.3651 17.2367 70.3651 15.9859 65.0158C14.7351 59.6666 16.507 51.197 17.5494 47.6309C17.81 46.0707 20.52 43.084 29.2756 43.619C40.2201 44.2876 64.4543 43.619 69.1448 43.619C73.8353 43.619 78.5258 45.625 78.5258 49.6369C78.5258 53.6488 82.4922 68.4446 73.1112 68.4446",
    stroke: "#3D3935",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H112V112H0V0Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVtEHov);
export default __webpack_public_path__ + "static/media/vt_e_hov.90148d618b4b5f32cde65376932114fa.svg";
export { ForwardRef as ReactComponent };